import React, { useState } from "react"
import { Backdrop, Box, Menu, MenuItem, Typography, useTheme } from "@mui/material"
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import MoreVertIcon from "@mui/icons-material/MoreVert"
import styles from "./comment.module.scss"
import ProfileDisplayer from "components/ProfileDisplayer"
import styled from "@emotion/styled"
import { useDispatch } from "react-redux"
import { updateCommentStatusAction } from "redux/marketing/actions"
import { statusOptions } from "helpers/constant"
import moment from "moment"
import { initDateConvert } from "helpers/functions"

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  "&:not(:last-child)": {
    borderBottom: `1px solid ${theme.palette.primary.hover}`
  },
  padding: "12px 24px",
  "&:last-child": {
    paddingBottom: "10px"
  }
}))

const Comment = ({ tab, comment, selected, onToggle, questionId }) => {
  const theme = useTheme()
  const [anchorEl, setAnchorEl] = useState(false)
  const openMenu = Boolean(anchorEl)
  const dispatch = useDispatch()

  const onOptionsClick = (e) => {
    e.stopPropagation()
    setAnchorEl(e.currentTarget)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const handleUpdateComment = (id, status) => {
    const updated = [id]
    handleCommentStatusUpdate(updated, status)
    handleMenuClose()
  }

  const handleCommentStatusUpdate = (id, status) => {
    const payload = {
      status: status,
      comment_ids: id,
      excepted_ids: [],
      is_all_selected: false
    }
    dispatch(updateCommentStatusAction({ id: questionId, payload }))
  }

  return (
    <Box className="d-flex gap-4 mt-4">
      {selected ? (
        <CheckCircleIcon
          role="button"
          htmlColor={theme.palette.secondary.main}
          onClick={onToggle}
        />
      ) : (
        <RadioButtonUncheckedIcon role="button" onClick={onToggle} />
      )}
      <Box className={styles.container}>
        <Box className="d-flex gap-3 mb-2">
          <ProfileDisplayer image={comment?.user_image} />
          <Box sx={{ width: "200px" }}>
            <Typography>{comment?.user}</Typography>
            <Typography color={theme.palette.text.secondary}>
              {moment(initDateConvert(comment?.date, comment?.time)).format("DD/MM/YYYY")} •{" "}
              {moment(initDateConvert(comment?.date, comment?.time)).format("hh:mm A")}
            </Typography>
          </Box>
          <MoreVertIcon onClick={onOptionsClick} className={styles.icon} />
          <Backdrop sx={{ color: "#fff", zIndex: 1300 }} open={openMenu} onClick={handleMenuClose}>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={openMenu}
              onClose={handleMenuClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              PaperProps={{
                sx: {
                  marginTop: "15px",
                  backgroundColor: theme.palette.background.default,
                  borderRadius: "12px",
                  "& .MuiList-root": {
                    backgroundColor: theme.palette.background.default,
                    width: "225px",
                    boxSizing: "border-box",
                    padding: "10px 0"
                  }
                }
              }}>
              {statusOptions[tab]?.map((option, index) => (
                <StyledMenuItem
                  key={index}
                  onClick={() => handleUpdateComment(comment?.id, option.status)}>
                  <Typography variant="body1Regular">{option?.menuTitle}</Typography>
                </StyledMenuItem>
              ))}
            </Menu>
          </Backdrop>
        </Box>
        <Box className={styles.comment}>
          {comment?.selected_comment && (
            <Typography variant="h5Italic">{comment?.selected_comment}</Typography>
          )}
          {comment?.input_comment && (
            <Typography variant="body4Regular" color={theme.palette.text.secondary}>
              {comment?.input_comment}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default Comment
